import { render, staticRenderFns } from "./StatusInvoices.vue?vue&type=template&id=470af13e&"
import script from "./StatusInvoices.vue?vue&type=script&lang=js&"
export * from "./StatusInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports